import React from "react";
import { getColorByName } from "../../utils/color";
import styles from "./Badge.module.scss";
import clsx from "clsx";
export const SemanticBadge = (props) => {
    var _a;
    const color = props.color ? getColorByName(props.color) : undefined;
    const colorRGB = props.color ? getColorByName(props.color, true) : undefined;
    return (React.createElement("div", { className: clsx(styles.SemanticBadge, props.className), style: props.color ? { backgroundColor: `rgba(${colorRGB}, 0.1)` } : undefined },
        props.icon && (React.createElement(props.icon, { size: (_a = props.iconSize) !== null && _a !== void 0 ? _a : 24, color: props.color ? getColorByName(props.color) : "color_error" })),
        React.createElement("p", { className: styles.SemanticText, style: color ? { color } : undefined }, props.text)));
};
//# sourceMappingURL=SemanticBadge.js.map